<template>
    <div>
        <div class="columns">
            <div class="column">
                <div class="level p-0 m-0">
                    <div class="level-left">
                        <div class="level-item">Lista e sektorëve</div>
                    </div>
                    <div class="level-right">
                        <div class="level">
                            <a @click.prevent="create_sector">
                                <span class="mr-2">Krijo</span>
                                <i class="fa fa-plus"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <table class="table mt-4">
                    <thead>
                        <tr>
                            <th>Emri</th>
                            <th>Modifiko</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sec in sectors" :key="sec.guid || sec.id">
                            <td>{{ sec.name }}</td>
                            <td><a href="" @click.prevent="edit_sector(sec)"><i class="fa fa-pencil"></i></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="column is-5" v-if="form_edit || form_create">
                <DaForm v-if="form_create" @submitted="submitSector" :form="form_create">
                </DaForm>

                <DaForm v-if="form_edit"
                @submitted="submitSector"
                :form="form_edit"
                >
                </DaForm>
            </div>
        </div>
    </div>
</template>

<script>
import DaForm from "@/components/daform/index.vue";
import createSector from "./forms/create";
import editSector from "./forms/edit";
import SectorService from "@/services/Sector";
export default {
    components: {
        DaForm
    },
    data() {
        return {
            sectors: [],
            selectedSector: {},
            form_create: null,
            form_edit: null,
        };
    },
    methods: {
        create_sector() {
            this.form_edit = null;
            this.form_create = createSector.form();
        },
        edit_sector(sec) {
            this.form_create = null;
            this.form_edit = null;
            setTimeout(() => {
                this.form_edit = editSector.form(sec);
                this.selectedSector = sec;
            });
        },
        async submitSector(d) {
            try {
                if (this.form_create != null) {
                    const sector = await SectorService.createSector(d);
                    if (!sector || typeof sector !== 'object') {
                        this.$toast.error("Sektori u krijua por nuk u kthye nga serveri. Rifreskoni faqen.");
                        return;
                    }
                    this.$toast.success("Sektori u krijua me sukses");
                    const list = this.sectors;
                    const plain = { ...sector };
                    setTimeout(() => {
                        this.sectors = [...list, plain];
                        this.form_create = null;
                        if (this.$root.selected_one) this.$root.selected_one = {};
                    }, 0);
                } else {
                    d.guid = this.selectedSector.guid;
                    const sector = await SectorService.editSector(d);
                    if (!sector || typeof sector !== 'object') {
                        this.$toast.error("Nuk u kthye rezultat nga serveri.");
                        return;
                    }
                    this.$toast.success("Sektori u modifikua me sukses");
                    const plain = { ...sector };
                    setTimeout(() => {
                        this.sectors = this.sectors.map(a => (a.guid === plain.guid ? plain : a));
                        this.form_edit = null;
                        if (this.$root.selected_one) this.$root.selected_one = {};
                    }, 0);
                }
            } catch (err) {
                const message = err.response?.data?.message || err.response?.data?.errors ? Object.values(err.response.data.errors).flat().join(" ") : (err.message || "Diçka shkoi keq. Provoni përsëri.");
                this.$toast.error(message);
            }
        }
    },
    async created() {
        this.sectors = await SectorService.getSectors();
    }
};
</script>

<style lang="scss" scoped>
</style>
